import type { ReactNode } from "react";
import { Button } from "../../components/ui/Button";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "../../components/ui/Card";

interface Props {
  client_name: string;
  params: Record<string, string>;
}

// Plain HTML form posts, not Inertia visits: Atlas answers with a redirect to
// Claude (another site), which an Inertia request cannot follow.
function OauthForm({ params, method, children }: { params: Record<string, string>; method: "post" | "delete"; children: ReactNode }) {
  const csrfToken = document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content ?? "";

  return (
    <form method="post" action="/oauth/authorize" className="flex-1">
      <input type="hidden" name="authenticity_token" value={csrfToken} />
      {method === "delete" && <input type="hidden" name="_method" value="delete" />}
      {Object.entries(params).map(([name, value]) => (
        <input key={name} type="hidden" name={name} value={value} />
      ))}
      {children}
    </form>
  );
}

// The copy names Claude directly (not client_name): registration accepts only
// Claude's callback URLs, so the client is always Claude.
export default function Allow({ params }: Props) {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-muted/40 px-4">
      <div className="flex items-center gap-2.5 mb-8">
        <div className="w-[30px] h-[30px] rounded-md bg-foreground text-background flex items-center justify-center text-sm font-semibold">A</div>
        <span className="text-sm font-semibold text-foreground" style={{ letterSpacing: "-0.01em" }}>ATLAS AI</span>
      </div>

      <Card className="w-full max-w-sm">
        <CardHeader>
          <CardTitle className="text-xl">Allow Claude to read your Atlas data?</CardTitle>
          <CardDescription>Claude can read what you can see in Atlas. It cannot change anything.</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="flex gap-3">
            <OauthForm params={params} method="delete">
              <Button type="submit" variant="outline" className="w-full">Cancel</Button>
            </OauthForm>
            <OauthForm params={params} method="post">
              <Button type="submit" className="w-full">Allow</Button>
            </OauthForm>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
